import { render, staticRenderFns } from "./LocationDialog.vue?vue&type=template&id=3b5c90ea&scoped=true"
import script from "./LocationDialog.vue?vue&type=script&lang=js"
export * from "./LocationDialog.vue?vue&type=script&lang=js"
import style0 from "./LocationDialog.vue?vue&type=style&index=0&id=3b5c90ea&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b5c90ea",
  null
  
)

export default component.exports